import Backbone from 'backbone'
import template from './calendar-period-selector.hbs'
import calendars from 'scoreboard/components/calendars'
import globals from 'scoreboard/components/globals'
import _ from 'lodash'
import PeriodSelector from './period-selector'
import select from 'scoreboard-select'
import i18n from 'scoreboard/components/i18n'

/**
 * A combination of 3 dropdowns that allow for selecting a calendar period.  The
 * 3 dropdowns are calendar, period, and year.  (There can also be just 2
 * dropdowns for yearly calendars).
 *
 * Options:
 *     periodId - (optional) the initial period to show in the selector
 *     confirm - (optional, default true) whether to include a confirm button
 *     name - (optional) specifies name attribute for use with form-helper
 */
var CalendarPeriodSelector = Backbone.View.extend({

	className: 'calendar-period-selector',

	events: {
		'change .calendar': 'renderCalendar',
		'click .button-primary': 'submit'
	},

	initialize: function(options) {
		this.options = options || {}
		this.periodId = options.periodId || globals.periodId
		this.confirm = _.isUndefined(options.confirm) ? true : options.confirm
		this.extraClass = options.extraClass
	},

	render: function() {
		this.$el.html(template())

		this.calendarDropdown = this.$('select.calendar')

		// render calendar dropdown
		_.each(calendars.calendars, function(calendar) {
			// #26896 don't show calendars with no periods defined
			if (_.isEmpty(calendar.periods)) {
				return
			}
			this.calendarDropdown.append(new Option(calendar.label, calendar.id))
		}.bind(this))

		var calendarId = null
		if (this.periodId) {
			calendarId = calendars.periodsById[this.periodId].calendar.id
		}
		this.trigger('show')

		if (this.extraClass) {
			this.$el.addClass(this.extraClass)
		}

		if (!this.confirm) {
			this.$('.button-primary').remove()
		}

		this.$el.data('view', this)
		// be sure to leave the guard against this.options being null here.  for
		// some reason i couldn't figure out it was coming through as null in
		// unit tests even though in the initialize method we clearly set it to
		// an empty object
		if (this.options && this.options.name) {
			this.$el.attr('name', this.options.name)
		}

		// Needs to go before calling select() so that the selected/starging
		// states of the selects are correct based on the calendarId/this.periodId #27439
		this.renderCalendar(calendarId)

		// Render selects. Override the results rendering because the values
		// there have already been escaped and we don't need scoreboard-select
		// to escape those strings again #26324
		select(this.el.querySelectorAll('select'), {
			render: {
				option: o => o.label
			}
		})

		return this
	},

	renderCalendar: function(e) {
		var calendarId = _.isNumber(e) ? e : this.calendarDropdown.val()
		var {id:periodId} = calendars.correspondingPeriod(calendarId, this.periodId)

		this.$('.calendar-container select.calendar').val(calendarId)

		this.periodSelector && this.periodSelector.remove()
		let backToDefaultButton = !_.isNil(this.backToDefaultButton) ?
			this.backToDefaultButton : true
			this.$el.toggleClass('has-back-to-default-button', backToDefaultButton)
		this.periodSelector = new PeriodSelector({
			periodId,
			calendarId,
			backToDefaultButton
		})
		this.periodSelector.on('backToDefaultDate', () => this.submit())
		if (this.confirm) {
			this.togglePrimaryButton(periodId)
			this.periodSelector.on('period', id => this.togglePrimaryButton(id))
		}

		// If calendar period selector is for a briefing and showing a specific date (not relative to the global date),
		// there is a layout adjustment to show that. Issue #23217
		if (this.options && this.options.briefingSpecificPeriodId && _.isNil(this.briefingSpecificPeriodStyled)) {
			// Show the actual period at the top as a reference.
			let actualPeriodLabel = calendars.periodsById[this.options.briefingSpecificPeriodId].label
			let actualPeriodInfo = `<div class="actual-period">`
				+ `<div>${i18n.get('common.calendar.period.actual')}</div>`
				+ `<div>${_.escape(actualPeriodLabel)}</div>`
				+ '</div>'
			// Show the specific period information underneath
			let specificPeriodText = `<span class="relative-text">${_.escape(i18n.get('common.specificPeriod'))}</span>`
			let slideInfo = `<div class="slide-information">${i18n.get('briefingBooks.slide.relative', specificPeriodText)}</div>`
			this.$('.time-selector-content').prepend(slideInfo) // Then apply the additional layout/text in front of the selector contentxl
			this.$el
				.prepend(this.$('.time-selector-content')) // First move the selector content below
				.prepend(actualPeriodInfo)
			this.briefingSpecificPeriodStyled = true
		}

		// render the period dropdown
		this.$('.period-selector-container').empty().append(this.periodSelector.el)
		this.periodSelector.render()
	},

	togglePrimaryButton: function(id) {
		this.$('.button-primary').toggleClass('is-disabled', parseInt(id) === this.periodId)
	},

	// handles the user clicking on the primary button
	submit: function(e) {
		this.trigger('change:period', this.periodSelector.val())
	},

	val: function(periodId) {
		if (_.isUndefined(periodId)) {
			return this.periodSelector.val(periodId)
		} else {
			var period = calendars.periodsById[periodId]
			this.calendarDropdown.val(period.calendar.id)
			this.periodSelector.val(periodId)
		}
	},

	remove: function() {
		this.trigger('hide')
		this.periodSelector && this.periodSelector.remove()
		Backbone.View.prototype.remove.apply(this, arguments)
	}

})

export default CalendarPeriodSelector

CalendarPeriodSelector.__filename__ = 'components/calendar-period-selector.js'
